module.exports = __webpack_public_path__ + "static/media/mlanghku.8204b9ee.png";